module.exports = __webpack_public_path__ + "img/new.5bea09d2.png";